exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content{padding:10px 15px;border-radius:unset;height:100%}", ""]);

// exports
